"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.purple = void 0;
exports.purple = {
    c10: '#42005B',
    c20: '#630087',
    c30: '#8600B6',
    c40: '#AB00E7',
    c50: '#C02BFF',
    c60: '#C762FF',
    c70: '#D28FFF',
    c80: '#E7C8FF',
    c90: '#F7EDFF',
    c100: '#FFFFFF',
};
//# sourceMappingURL=purple.js.map